import Vue from 'vue';
import {
  Button,
  Checkbox,
  Col,
  DatePicker,
  Form,
  FormItem,
  Input,
  Message,
  Option,
  Row,
  Select,
  Upload,
  Radio,
  Tooltip,
} from 'element-ui';
import lang from 'element-ui/lib/locale/lang/en';
import locale from 'element-ui/lib/locale';

locale.use(lang);

Vue.use(Button);
Vue.use(Row);
Vue.use(Col);
Vue.use(Form);
Vue.use(FormItem);
Vue.use(Input);
Vue.use(Select);
Vue.use(Option);
Vue.use(Checkbox);
Vue.use(DatePicker);
Vue.use(Upload);
Vue.use(Radio);
Vue.use(Tooltip);
Vue.prototype.$message = Message;
